import React from 'react';
import Typography from 'helpers/fonts';
import { useSmallScreen } from 'helpers/isSmallScreen';

export interface OverviewListProps {
  steps: Array<string>;
}
export interface OverviewListItemProps {
  number: number;
  text: string;
  isSmallScreen?: boolean;
  style?: React.CSSProperties;
}

const OverviewListItem: React.FunctionComponent<OverviewListItemProps> = ({
  number,
  text,
  isSmallScreen,
  style,
}: OverviewListItemProps) => {
  return (
    <div
      style={{
        display: 'flex',
        marginBottom: number === 5 ? '0' : '30px',
        alignItems: 'center',
        ...style,
      }}
    >
      <Typography
        styleid={11}
        style={{
          color: '#fff',
          borderRadius: '50%',
          width: '30px',
          height: '30px',
          background: `${Theme['@primary-color']}`,
          textAlign: 'center',
          margin: '0 12px',
          lineHeight: '35px',
        }}
      >
        {number}
      </Typography>
      <Typography
        styleid={isSmallScreen ? 5 : 2}
        style={{
          display: 'flex',
          alignItems: 'center',
          margin: '0 12px',
          textAlign: 'center',
          marginBottom: -4,
        }}
      >
        {text}
      </Typography>
    </div>
  );
};

const OverviewList: React.FunctionComponent<OverviewListProps> = ({
  steps,
}: OverviewListProps) => {
  const isSmallScreen = useSmallScreen();
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {steps.map((s, index) => (
        <OverviewListItem
          isSmallScreen={isSmallScreen}
          text={s}
          number={index + 1}
          key={index}
          style={{ color: Theme['@black'] }}
        />
      ))}
    </div>
  );
};

export default OverviewList;
